// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowUpIcon = {
    data: `<svg viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.98 8.76001L8.47998 1.26001L0.97998 8.76001" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-up' as const
};